import { render, staticRenderFns } from "./OldOak.vue?vue&type=template&id=74c7b3b6&"
import script from "./OldOak.vue?vue&type=script&lang=js&"
export * from "./OldOak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports